import "./NlpHeaders.css";
import React, {useEffect, useState} from "react";
import NlpSidebarHeader from "./NlpSidebarHeader/NlpSidebarHeader";
import NlpChatHeader from "./NlpChatHeader/NlpChatHeader";

const NlpHeaders: React.FC = () => {

    return (
        <div className="NlpHeaders">
            <NlpChatHeader></NlpChatHeader>
            <NlpSidebarHeader></NlpSidebarHeader>
        </div>
    );
};

export default NlpHeaders;
